<!-- NEW HOME UI — disabled while showLegacyUi is true -->
<ng-container *ngIf="!showLegacyUi">
<div
  class="pc-home-dashboard"
  [class.pc-home-dashboard--light]="!isDarkMode()"
>
  <div class="pc-home-dashboard__error" *ngIf="dashboardLoadError">
    <span>Unable to load dashboard data. Please try again.</span>
    <button type="button" (click)="retryDashboard()">Retry</button>
  </div>

  <div class="pc-home-top-bar">
    <div class="pc-home-panel__filters">
      <div class="pc-home-filter-field" *ngIf="userName === 'Meraki - Operations'">
        <span class="pc-home-filter-field__label">Client</span>
        <div class="pc-home-client-filter">
          <app-pc-multi-select-filter
            [lightMode]="!isDarkMode()"
            placeholder="All Clients"
            [options]="clientList"
            [(selected)]="selectedClients"
            (selectedChange)="onClientSelectionChange($event)"
          >
          </app-pc-multi-select-filter>
        </div>
      </div>

      <div class="pc-home-filter-field">
        <span class="pc-home-filter-field__label">From Date</span>
        <input
          class="pc-home-date-input"
          type="date"
          [(ngModel)]="selectedHomeFromDate"
          [max]="selectedHomeToDate || null"
          (ngModelChange)="onHomeDateFilterChange()"
          aria-label="From date filter"
        />
      </div>

      <div class="pc-home-filter-field">
        <span class="pc-home-filter-field__label">To Date</span>
        <input
          class="pc-home-date-input"
          type="date"
          [(ngModel)]="selectedHomeToDate"
          [min]="selectedHomeFromDate || null"
          (ngModelChange)="onHomeDateFilterChange()"
          aria-label="To date filter"
        />
      </div>

      <div class="pc-home-filter-field">
        <span class="pc-home-filter-field__label">Segment</span>
        <mat-form-field appearance="outline" class="pc-home-segment-select">
          <mat-select
            [panelClass]="selectPanelClass"
            [value]="selectedHomeSegment"
            (selectionChange)="onHomeSegmentChange($event.value)"
            aria-label="Segment filter"
          >
            <mat-option *ngFor="let segment of homeSegmentOptions" [value]="segment">
              {{ segment }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </div>

<div class="statistics-container" [ngClass]="{ 'dark-theme': isDarkMode() }">

  <!-- Total Vessels -->
  <mat-card
    class="stat-card total-vessels"
    (click)="navigateVessels('totalVessels')"
    matTooltip="Total vessels currently monitored in the fleet."
    [matTooltipClass]="tooltipClass"
  >
    <div class="card-icon">
      <mat-icon>directions_boat</mat-icon>
    </div>

    <mat-card-title>Total Vessels</mat-card-title>

    <mat-card-content>
      <h2 *ngIf="!isLoadingStats; else statsSkeleton">
        {{ getSummaryDisplay(totalVessels) }}
      </h2>
    </mat-card-content>
  </mat-card>


  <!-- In Transit -->
  <mat-card
    class="stat-card in-transit"
    (click)="navigateVessels('Transit')"
    style="cursor: pointer;"
    matTooltip="Vessels currently reporting active port consumption data."
    [matTooltipClass]="tooltipClass"
  >
    <div class="card-icon">
      <mat-icon>check_circle</mat-icon>
    </div>

    <mat-card-title>In Transit</mat-card-title>

    <mat-card-content>
      <h2 *ngIf="!isLoadingStats; else statsSkeleton">
        {{ getSummaryDisplay(transit) }}
      </h2>
    </mat-card-content>
  </mat-card>


  <!-- Load Port -->
  <mat-card
    class="stat-card load-port"
    (click)="navigateVessels('shipUnderperformanceTcp')"
    matTooltip="Port calls with underperformance against warranties at load port."
    [matTooltipClass]="tooltipClass"
  >
    <div class="card-icon">
      <mat-icon>edit_note</mat-icon>
    </div>

    <mat-card-title>Load Port</mat-card-title>

    <mat-card-content>
      <h2 *ngIf="!isLoadingStats; else statsSkeleton">
        {{ getSummaryDisplay(underPerformanceTcp) }}
      </h2>
    </mat-card-content>
  </mat-card>


  <!-- Discharge Port -->
  <mat-card
    class="stat-card discharge-port"
    (click)="navigateVessels('shipUnderperformanceDesign')"
    matTooltip="Port calls with underperformance against design at discharge port."
    [matTooltipClass]="tooltipClass"
  >
    <div class="card-icon">
      <mat-icon>anchor</mat-icon>
    </div>

    <mat-card-title>Discharge Port</mat-card-title>

    <mat-card-content>
      <h2 *ngIf="!isLoadingStats; else statsSkeleton">
        {{ getSummaryDisplay(underPerformanceDesign) }}
      </h2>
    </mat-card-content>
  </mat-card>


  <!-- Actual Consumption -->
  <mat-card
    class="stat-card actual-consumption"
    matTooltip="Total actual fuel consumption recorded across all port operations (MT)."
    [matTooltipClass]="tooltipClass"
  >
    <div class="card-icon">
      <mat-icon>local_gas_station</mat-icon>
    </div>

    <mat-card-title>Actual Consumption (MT)</mat-card-title>

    <mat-card-content>
      <h2 *ngIf="!isLoadingConsumption; else statsSkeleton">
        {{ getSummaryDisplay(actualConsumptionMt) }}
      </h2>
    </mat-card-content>
  </mat-card>


  <!-- Optimized Consumption -->
  <mat-card
    class="stat-card optimized-consumption"
    matTooltip="Estimated optimized fuel consumption based on optimization and design targets (MT)."
    [matTooltipClass]="tooltipClass"
  >
    <div class="card-icon">
      <mat-icon>speed</mat-icon>
    </div>

    <mat-card-title>Warranted consumption (MT)</mat-card-title>

    <mat-card-content>
      <h2 *ngIf="!isLoadingConsumption; else statsSkeleton">
        {{ getSummaryDisplay(optimizedConsumptionMt) }}
      </h2>
    </mat-card-content>
  </mat-card>


  <!-- Fuel Saved -->
  <mat-card
    class="stat-card fuel-saved"
    matTooltip="Fuel saved compared with optimized consumption. Positive values indicate savings."
    [matTooltipClass]="tooltipClass"
  >
    <div class="card-icon">
      <mat-icon>savings</mat-icon>
    </div>

    <mat-card-title>Fuel Saved (MT)</mat-card-title>

    <mat-card-content>
      <h2 *ngIf="!isLoadingConsumption; else statsSkeleton">
        {{ getSummaryDisplay(fuelSavedMt) }}
      </h2>

      <span
        class="stat-sub"
        *ngIf="!isLoadingConsumption && fuelSavedVsDesignPct != null"
      >
        vs Optimization

        <!-- <mat-icon class="trend-icon">
          arrow_drop_up
        </mat-icon> -->

        {{ formatDashboardPercent(fuelSavedVsDesignPct) }}
      </span>
    </mat-card-content>
  </mat-card>

</div>

  <!-- Analytics: Leg Wise + Optimization Compliance. Prediction Accuracy kept commented out. -->
  <div class="pc-home-analytics">
    <div class="pc-home-analytics-top">
      <section class="pc-home-panel pc-home-panel--leg">
        <header class="pc-home-panel__header">
          <div class="pc-home-panel__heading">
            <div class="pc-home-panel__title-wrap">
              <h3 class="pc-home-panel__title">LEG WISE CONSUMPTION</h3>
              <span class="pc-home-unit-chip">{{ legComparisonUnit }}</span>
              <mat-icon
                class="pc-home-panel__info"
                matTooltip="Compare actual consumption against warranted or optimization consumption by operation."
                [matTooltipClass]="tooltipClass"
              >info</mat-icon>
            </div>
            <p class="pc-home-panel__subtitle">Compare Actual vs Warranted / Optimization Consumption</p>
          </div>
        </header>

        <mat-radio-group
          class="pc-home-leg-mode pc-home-leg-mode--segmented"
          [(ngModel)]="legComparisonMode"
          aria-label="Leg wise comparison mode"
        >
          <mat-radio-button value="warranted">Warranted Consumption</mat-radio-button>
          <mat-radio-button value="optimization">Optimization Consumption</mat-radio-button>
        </mat-radio-group>

        <div class="pc-home-leg-table-wrap">
          <table class="pc-home-leg-table">
            <colgroup>
              <col class="pc-home-leg-table__col-leg" />
              <col class="pc-home-leg-table__col-num" span="4" />
              <col class="pc-home-leg-table__col-status" />
            </colgroup>
            <thead>
              <tr>
                <th>Operation Leg</th>
                <th matTooltip="Actual recorded consumption." [matTooltipClass]="tooltipClass">Actual (MT)</th>
                <th [matTooltip]="legComparisonColumnTooltip" [matTooltipClass]="tooltipClass">
                  {{ legComparisonColumnLabel }}
                </th>
                <th matTooltip="Consumption savings or excess in MT." [matTooltipClass]="tooltipClass">Difference (MT)</th>
                <th matTooltip="Percentage difference against actual consumption." [matTooltipClass]="tooltipClass">Difference (%)</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of legComparisonRows" class="no-hover" [class.is-total]="row.isTotal">
                <td class="pc-home-leg-table__leg">
                  <div class="pc-home-leg-table__leg-inner">
                    <mat-icon *ngIf="!row.isTotal">{{ row.icon }}</mat-icon>
                    <span class="pc-home-leg-table__leg-label">{{ row.label }}</span>
                  </div>
                </td>
                <td class="tone-cyan">{{ formatDashboardNumber(row.actual) }}</td>
                <td class="tone-green">{{ formatDashboardNumber(getLegComparisonValue(row)) }}</td>
                <td
                  [class.tone-green]="isPositiveSavings(getLegDifferenceMt(row))"
                  [class.tone-red]="getLegDifferenceMt(row) != null && getLegDifferenceMt(row)! < 0"
                >
                  {{ formatLegDifferenceNumber(getLegDifferenceMt(row)) }}
                </td>
                <td
                  [class.tone-green]="isPositiveSavings(getLegDifferencePct(row))"
                  [class.tone-red]="getLegDifferencePct(row) != null && getLegDifferencePct(row)! < 0"
                >
                  {{ formatLegDifferencePercent(getLegDifferencePct(row)) }}
                </td>
                <td class="pc-home-leg-table__status">
                  <span
                    class="pc-home-status pc-home-leg-status"
                    [class.pc-home-status--better]="isPositiveSavings(getLegDifferenceMt(row))"
                    [class.pc-home-status--worse]="getLegDifferenceMt(row) != null && getLegDifferenceMt(row)! < 0"
                    *ngIf="!row.isTotal && getLegDifferenceMt(row) != null; else legStatusDash"
                  >
                    <mat-icon>{{ isPositiveSavings(getLegDifferenceMt(row)) ? 'check_circle' : 'cancel' }}</mat-icon>
                    {{ isPositiveSavings(getLegDifferenceMt(row)) ? 'Better' : 'Worse' }}
                  </span>
                  <ng-template #legStatusDash>
                    <span *ngIf="row.isTotal; else dashOnly"></span>
                    <ng-template #dashOnly>--</ng-template>
                  </ng-template>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="pc-home-leg-insights">
          <article class="pc-home-leg-insights__item">
            <mat-icon>insights</mat-icon>
            <div>
              <strong>How to read this table</strong>
              <p>Each row compares actual fuel use against your selected reference — Warranted or Optimization — for that operation leg.</p>
            </div>
          </article>
          <article class="pc-home-leg-insights__item">
            <mat-icon>trending_down</mat-icon>
            <div>
              <strong>Positive difference = savings</strong>
              <p>When actual is below the reference, difference shows green — you consumed less fuel than planned.</p>
            </div>
          </article>
          <article class="pc-home-leg-insights__item">
            <mat-icon>swap_horiz</mat-icon>
            <div>
              <strong>Switch comparison mode</strong>
              <p>Use the toggle above to view performance against Charter Party warranted values or vessel optimization targets.</p>
            </div>
          </article>
        </div>

        <p class="pc-home-panel__note">
          <span class="pc-home-panel__dot"></span>
          Positive difference indicates savings.
        </p>
      </section>

      <section class="pc-home-panel pc-home-panel--compliance">
        <header class="pc-home-panel__header">
          <div class="pc-home-panel__heading">
            <div class="pc-home-panel__title-wrap">
              <h3 class="pc-home-panel__title">OPTIMIZATION COMPLIANCE (Voyage Count)</h3>
              <mat-icon
                class="pc-home-panel__info"
                matTooltip="Compliance represents how closely actual consumption met the optimization target."
                [matTooltipClass]="tooltipClass"
              >info</mat-icon>
            </div>
            <p class="pc-home-panel__subtitle">How voyages perform against optimization targets.</p>
          </div>
        </header>

        <mat-form-field appearance="outline" class="pc-home-segment-select pc-home-compliance-leg-select">
          <mat-select
            [panelClass]="selectPanelClass"
            [value]="complianceLegFilter"
            (selectionChange)="onComplianceLegChange($event.value)"
            aria-label="Compliance operation leg filter"
          >
            <mat-option *ngFor="let option of complianceLegOptions" [value]="option.value">
              {{ option.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <div class="pc-home-compliance-body" *ngIf="!isLoadingCompliance && hasComplianceData(); else complianceState">
          <div class="pc-home-compliance-main">
            <div class="pc-home-compliance-chart">
              <div
                *ngIf="complianceChart"
                [chart]="complianceChart"
                class="pc-home-chart-box"
              ></div>
              <div class="pc-home-compliance-center">
                <strong>{{ formatDashboardNumber(complianceTotalVoyages) }}</strong>
                <span>Total Operations</span>
              </div>
            </div>
            <ul class="pc-home-compliance-legend">
              <li
                *ngFor="let slice of complianceSlices"
                [matTooltip]="slice.tooltip"
                [matTooltipClass]="tooltipClass"
              >
                <span class="pc-home-compliance-legend__swatch" [style.background-color]="slice.color"></span>
                <span class="pc-home-compliance-legend__label">{{ slice.label }}</span>
                <span class="pc-home-compliance-legend__value">
                  {{ formatDashboardNumber(slice.count) }} ({{ formatDashboardPercent(slice.percent, 0) }})
                </span>
              </li>
            </ul>
          </div>

          <div class="pc-home-compliance-cards">
            <article
              class="pc-home-compliance-card"
              *ngFor="let slice of complianceSlices"
              [class.pc-home-compliance-card--achieved]="slice.key === 'achieved'"
              [class.pc-home-compliance-card--partial]="slice.key === 'partial'"
              [class.pc-home-compliance-card--exceeded]="slice.key === 'exceeded'"
            >
              <span class="pc-home-compliance-card__label">{{ slice.label }}</span>
              <strong class="pc-home-compliance-card__count">{{ formatDashboardNumber(slice.count) }}</strong>
              <span class="pc-home-compliance-card__pct">{{ formatDashboardPercent(slice.percent, 0) }}</span>
            </article>
          </div>
        </div>
        <p class="pc-home-panel__note">
          Compliance represents how closely actual consumption met the optimization target.
        </p>
        <ng-template #complianceState>
          <div class="pc-home-empty" *ngIf="!isLoadingCompliance">
            No optimization compliance data available for the selected filters.
          </div>
          <ng-container *ngIf="isLoadingCompliance">
            <ng-container *ngTemplateOutlet="panelSkeleton"></ng-container>
          </ng-container>
        </ng-template>
      </section>
    </div>

    <!--
      PREDICTION ACCURACY — intentionally commented out. Do not uncomment unless product asks.
      <section class="pc-home-panel pc-home-panel--prediction">
        <header class="pc-home-panel__header">
          <div class="pc-home-panel__heading">
            <div class="pc-home-panel__title-wrap">
              <h3 class="pc-home-panel__title">PREDICTION ACCURACY (Fleet Level)</h3>
              <mat-icon
                class="pc-home-panel__info"
                matTooltip="Monthly optimization prediction vs actual consumption."
                [matTooltipClass]="tooltipClass"
              >info</mat-icon>
            </div>
            <p class="pc-home-panel__subtitle">How prediction performance changes over time.</p>
          </div>
        </header>

        <div class="pc-home-prediction-body" *ngIf="!isLoadingPrediction && hasPredictionChartData(); else predictionState">
          <div class="pc-home-prediction-chart">
            <div
              *ngIf="predictionChart"
              [chart]="predictionChart"
              class="pc-home-chart-box pc-home-chart-box--line"
            ></div>
          </div>

          <aside class="pc-home-prediction-insights">
            <div class="pc-home-kpi-row">
              <article class="pc-home-kpi-card">
                <div class="pc-home-kpi-card__label-row">
                  <span class="pc-home-kpi-card__label">Average Prediction Error</span>
                  <mat-icon class="pc-home-kpi-card__info" matTooltip="Mean absolute percentage error between prediction and actual." [matTooltipClass]="tooltipClass">info_outline</mat-icon>
                </div>
                <strong class="pc-home-kpi-card__value tone-green">
                  {{ predictionKpis.avgError != null ? formatDashboardPercent(predictionKpis.avgError) : '--' }}
                </strong>
              </article>
              <article class="pc-home-kpi-card">
                <div class="pc-home-kpi-card__label-row">
                  <span class="pc-home-kpi-card__label">MAPE</span>
                  <mat-icon class="pc-home-kpi-card__info" matTooltip="Mean absolute percentage error across all matched records." [matTooltipClass]="tooltipClass">info_outline</mat-icon>
                </div>
                <strong class="pc-home-kpi-card__value tone-cyan">
                  {{ predictionKpis.mape != null ? formatDashboardPercent(predictionKpis.mape) : '--' }}
                </strong>
              </article>
              <article class="pc-home-kpi-card">
                <div class="pc-home-kpi-card__label-row">
                  <span class="pc-home-kpi-card__label">Accuracy</span>
                  <mat-icon class="pc-home-kpi-card__info" matTooltip="Overall prediction accuracy derived from error rate." [matTooltipClass]="tooltipClass">info_outline</mat-icon>
                </div>
                <strong class="pc-home-kpi-card__value tone-green">
                  {{ predictionKpis.accuracy != null ? formatDashboardPercent(predictionKpis.accuracy) : '--' }}
                </strong>
              </article>
              <article class="pc-home-kpi-card">
                <div class="pc-home-kpi-card__label-row">
                  <span class="pc-home-kpi-card__label">Data Completeness</span>
                  <mat-icon class="pc-home-kpi-card__info" matTooltip="Share of records with both actual and predicted values." [matTooltipClass]="tooltipClass">info_outline</mat-icon>
                </div>
                <strong class="pc-home-kpi-card__value tone-green">
                  {{ predictionKpis.completeness != null ? formatDashboardPercent(predictionKpis.completeness) : '--' }}
                </strong>
              </article>
            </div>

            <div class="pc-home-prediction-trend" *ngIf="predictionTrendSummary.length">
              <article class="pc-home-prediction-trend__item" *ngFor="let item of predictionTrendSummary">
                <span class="pc-home-prediction-trend__label">{{ item.label }}</span>
                <strong
                  class="pc-home-prediction-trend__value"
                  [class.tone-green]="item.tone === 'positive'"
                  [class.tone-red]="item.tone === 'negative'"
                  [class.tone-cyan]="item.tone === 'info'"
                >
                  {{ item.value }}
                </strong>
              </article>
            </div>
          </aside>
        </div>
        <ng-template #predictionState>
          <div class="pc-home-empty" *ngIf="!isLoadingPrediction">
            No prediction data available for this period.
          </div>
          <ng-container *ngIf="isLoadingPrediction">
            <ng-container *ngTemplateOutlet="panelSkeleton"></ng-container>
          </ng-container>
        </ng-template>
      </section>
    -->
  </div>

  <!-- Fleet Performance removed from active Home Page (reference UI). -->

  <footer class="pc-home-footer">
    <span class="pc-home-footer__item pc-home-footer__live">
      <span class="pc-home-footer__dot" aria-hidden="true"></span>
      Live Data · Updated {{ lastUpdatedText }}
    </span>
    <span class="pc-home-footer__item">
      <mat-icon>autorenew</mat-icon>
      Data refreshed every 15 mins
    </span>
  </footer>
</div>
</ng-container>

<ng-template #statsSkeleton>
  <div class="skeleton-value skeleton"></div>
</ng-template>

<ng-template #panelSkeleton>
  <div class="pc-home-panel-skeleton skeleton"></div>
</ng-template>

<!-- LEGACY HOME UI — active while showLegacyUi is true -->
<ng-container *ngIf="showLegacyUi">
<div class="container">

 <div class="top-bar">

  <div class="client-filter-box" *ngIf="userName === 'Meraki - Operations'">
    <app-pc-multi-select-filter
      [lightMode]="!isDarkMode()"
      placeholder="Select Client"
      [options]="clientList"
      [(selected)]="selectedClients"
      (selectedChange)="onClientSelectionChange($event)">
    </app-pc-multi-select-filter>
  </div>

</div>
  <div class="statistics-container">
    <mat-card class="stat-card total-vessels" (click)="navigateVessels('totalVessels')" style="cursor: pointer">
      <div class="card-icon"><mat-icon>directions_boat</mat-icon></div>
      <mat-card-title>Total Vessels</mat-card-title>
      <mat-card-content>
        <h2 *ngIf="!isLoadingStats; else statsSkeleton">{{ totalVessels }}</h2>
      </mat-card-content>
    </mat-card>

    <mat-card class="stat-card active-vessels" [matTooltip]="
        'If you want to see the detailed view, click on this widget.'
      " (click)="navigateToActiveVessels()" style="cursor: pointer">
      <div class="card-icon"><mat-icon>check_circle</mat-icon></div>
      <mat-card-title>Active Vessels</mat-card-title>
      <mat-card-content>
        <h2 *ngIf="!isLoadingStats; else statsSkeleton">{{ activeVessels }}</h2>
      </mat-card-content>
    </mat-card>

    <mat-card class="stat-card inactive-vessels" (click)="navigateToActiveVessels()" [matTooltip]="
        'If you want to see the detailed view, click on this widget.'
      ">
      <div class="card-icon"><mat-icon>pause_circle</mat-icon></div>
      <mat-card-title>Inactive Vessels</mat-card-title>
      <mat-card-content>
        <h2 *ngIf="!isLoadingStats; else statsSkeleton">
          {{ inactiveVessels }}
        </h2>
      </mat-card-content>
    </mat-card>

    <mat-card class="stat-card underperformance-tcp" (click)="navigateVessels('shipUnderperformanceTcp')"
      matTooltipPosition="above" [matTooltip]="
        'If you want to see the detailed view, click on this widget.'
      ">
      <div class="card-icon"><mat-icon>speed</mat-icon></div>
      <mat-card-title> Load Port</mat-card-title>
      <mat-card-content>
        <h2 *ngIf="!isLoadingStats; else statsSkeleton">
          {{ underPerformanceTcp }}
        </h2>
      </mat-card-content>
    </mat-card>


    <mat-card class="stat-card underperformance-design" (click)="navigateVessels('shipUnderperformanceDesign')"
      [matTooltip]="
        'If you want to see the detailed view, click on this widget.'
      ">
      <div class="card-icon"><mat-icon>architecture</mat-icon></div>
      <mat-card-title> Discharge Port</mat-card-title>
      <mat-card-content>
        <h2 *ngIf="!isLoadingStats; else statsSkeleton">
          {{ underPerformanceDesign }}
        </h2>
      </mat-card-content>
    </mat-card>

    <mat-card class="stat-card idle" (click)="navigateVessels('Idle')" [matTooltip]="
        'If you want to see the detailed view, click on this widget.'
      ">
      <div class="card-icon"><mat-icon>pause</mat-icon></div>
      <mat-card-title>Idle</mat-card-title>
      <mat-card-content>
        <h2 *ngIf="!isLoadingStats; else statsSkeleton">{{ idel }}</h2>
      </mat-card-content>
    </mat-card>

    <mat-card class="stat-card cargo-operations" (click)="navigateVessels('CargoOperations')" [matTooltip]="
        'If you want to see the detailed view, click on this widget.'
      ">
      <div class="card-icon"><mat-icon>low_priority</mat-icon></div>
      <mat-card-title>Cargo operations</mat-card-title>
      <mat-card-content>
        <h2 *ngIf="!isLoadingStats; else statsSkeleton">
          {{ cargoOperationsCount }}
        </h2>
      </mat-card-content>
    </mat-card>

    <mat-card class="stat-card transit" (click)="navigateVessels('Transit')" [matTooltip]="
        'If you want to see the detailed view, click on this widget.'
      ">
      <div class="card-icon"><mat-icon>sailing</mat-icon></div>
      <mat-card-title>Transit</mat-card-title>
      <mat-card-content>
        <h2 *ngIf="!isLoadingStats; else statsSkeleton">{{ transit }}</h2>
      </mat-card-content>
    </mat-card>
  </div>

  <div class="row main-dashboard-row">
    <div class="col-md-6 left-panel">
      <div class="graphs-container side-by-side">
        <div class="graph-card premium-card">
          <div class="graph-header">
            <span class="graph-title">PC Benchmarking</span>
          </div>
          <div class="graph-content" (click)="openGraphPreview('pc')">
            <div *ngIf="!isLoadingPcChart; else graphSkeleton" [chart]="pcBenchmarkingChart" class="highcharts-box"></div>
          </div>
        </div>

        <div class="graph-card premium-card">
          <div class="graph-header">
            <span class="graph-title">TCP Benchmarking</span>
          </div>
          <div class="graph-content" (click)="openGraphPreview('tcp')">
            <div *ngIf="!isLoadingTcpChart; else graphSkeleton" [chart]="tcpBenchmarkingChart" class="highcharts-box"></div>
          </div>
        </div>
      </div>

      <div class="table-container-full">
        <div class="graph-card table" (click)="goToFleetView()" style="cursor:pointer">
          <div class="fleet-header">
            <span class="tableTitle">Fleet View</span>
          </div>
          <app-pc-fleet></app-pc-fleet>
        </div>
      </div>
    </div>

    <div class="col-md-6 right-panel">
      <div class="graph-card map-card premium-card">
        <div class="graph-header">
          <span class="graph-title">Fleet Route Map</span>
        </div>
        <div class="map-content">
          <div id="pcRouteMap" class="map-container-full"></div>
        </div>
      </div>
    </div>
  </div>

  <ng-template #graphSkeleton>
    <div class="skeleton-chart-container">
      <div class="skeleton-chart-bar skeleton" *ngFor="let i of [1,2,3,4,5]"></div>
    </div>
  </ng-template>

  <div
    class="graph-preview-layer"
    *ngIf="graphPreviewType"
    (click)="closeGraphPreview()"
    role="presentation"
  >
    <div
      class="graph-preview-panel"
      role="dialog"
      aria-modal="true"
      (click)="$event.stopPropagation()"
    >
      <div class="graph-preview-panel__chart">
        <div
          *ngIf="!isLoadingPreviewChart && previewChart"
          [chart]="previewChart"
          class="preview-highcharts-box"
        ></div>
      </div>
    </div>
  </div>

</div>
</ng-container>
